import { render, staticRenderFns } from "./ProjectFormPage.vue?vue&type=template&id=833f166a&lang=pug&"
import script from "./ProjectFormPage.vue?vue&type=script&lang=js&"
export * from "./ProjectFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports